"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Modal = require("./Modal.styles");
var _Modal2 = require("./Modal.labels");
var _Modal3 = require("./Modal.helpers");
var _ModalHeader = require("./partials/ModalHeader");
var _ModalContent = require("./partials/ModalContent");
var _ModalFooter = require("./partials/ModalFooter");
var _ModalFooterSection = require("./partials/ModalFooterSection");
var _Portal = require("../Portal");
var _Button = require("../../UI/Button");
var _hooks = require("../../hooks");
var _Icon = require("../../UI/Icon");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _dom = require("../../utilities/dom");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Modal = props => {
  const {
    id,
    layout = 'popup',
    isStandAlone = false,
    isWithCloseButton = true,
    children,
    isOpen = false
  } = props;
  const styles = (0, _Modal.useStyles)(props);
  const modalRef = (0, _react.useRef)(null);
  const modalCloseButtonRef = (0, _react.useRef)(null);
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const getLabel = (0, _hooks.useLabels)({
    labels: _Modal2.labels
  });
  const {
    handleCloseFromOutside,
    handleClose
  } = (0, _Modal3.getModalFunctions)(props);
  const WrapperTag = isStandAlone ? _Portal.Portal : _react.default.Fragment;
  const WrapperModalTag = layout === 'popup' ? 'dialog' : 'section';
  const handleModalKeyDown = event => {
    if (event.key === 'Escape') {
      modalCloseButtonRef.current?.click();
    } else if (modalRef.current && event.key === 'Tab') {
      const focusableElements = (0, _dom.getKeyboardFocusableElements)(modalRef.current);
      if (focusableElements.length > 0) {
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];
        if (document.activeElement === firstFocusableElement && event.shiftKey) {
          event.preventDefault();
          lastFocusableElement.focus();
        } else if (document.activeElement === lastFocusableElement && !event.shiftKey) {
          event.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }
  };
  (0, _react.useEffect)(() => {
    if (isOpen && modalRef.current) {
      const focusableElements = (0, _dom.getKeyboardFocusableElements)(modalRef.current);
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }
  }, [isOpen]);
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(WrapperTag, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      ref: modalRef,
      onKeyDown: handleModalKeyDown,
      className: styles['cc-Modal-container'],
      "data-testid": id ? `modal-container-${id}` : null,
      children: [!isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Modal-blocker'],
        onClick: handleCloseFromOutside,
        "data-testid": id ? `modal-blocker-${id}` : null
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(WrapperModalTag, {
        className: styles['cc-Modal'],
        "data-testid": id ? `modal-${id}` : null,
        children: [isWithCloseButton && layout !== 'inline' && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-Modal__close-btn'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            id: "ccModalCloseButton",
            ref: modalCloseButtonRef,
            shape: "round",
            onClick: handleClose,
            color: isMobileView ? 'basic' : 'primary',
            view: isMobileView ? 'outlined' : 'alternate',
            size: isMobileView ? 'small' : 'medium',
            customStyle: isMobileView ? {
              background: themeColors?.general.light,
              boxShadow: `0 ${pxToRem(3)} ${pxToRem(5)} ${themeColors?.basic.shadow}`
            } : {
              background: themeColors?.basic.main,
              color: themeColors?.general.text
            },
            ariaLabel: getLabel('close'),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              name: "Close",
              width: 14,
              height: 14
            })
          })
        }), children]
      })]
    })
  });
};
exports.Modal = Modal;
Modal.Header = _ModalHeader.ModalHeader;
Modal.Content = _ModalContent.ModalContent;
Modal.Footer = _ModalFooter.ModalFooter;
Modal.Footer.Section = _ModalFooterSection.ModalFooterSection;